module.exports = __webpack_public_path__ + "static/fonts/NeueAugenblick-Regular.86a8257f.woff";